import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <div className="sidebar">
      <Nav className="flex-column">
        <Nav.Link 
          as={Link} 
          to="/dashboard" 
          className={isActive('/dashboard') ? 'active' : ''}
        >
          <i className="bi bi-speedometer2"></i>
          Dashboard
        </Nav.Link>
        
        <Nav.Link 
          as={Link} 
          to="/clients" 
          className={isActive('/clients') ? 'active' : ''}
        >
          <i className="bi bi-people"></i>
          Clients
        </Nav.Link>
        
        <Nav.Link 
          as={Link} 
          to="/proposals" 
          className={isActive('/proposals') ? 'active' : ''}
        >
          <i className="bi bi-file-earmark-text"></i>
          Proposals
        </Nav.Link>
        
        <Nav.Link 
          as={Link} 
          to="/quotations" 
          className={isActive('/quotations') ? 'active' : ''}
        >
          <i className="bi bi-file-earmark-spreadsheet"></i>
          Quotations
        </Nav.Link>
        
        <Nav.Link 
          as={Link} 
          to="/settings" 
          className={isActive('/settings') ? 'active' : ''}
        >
          <i className="bi bi-gear"></i>
          Settings
        </Nav.Link>
      </Nav>
    </div>
  );
};

export default Sidebar;
